import { AutoComplete } from 'antd';
import Form, { FormItemProps } from 'antd/lib/form';
import * as React from 'react';
import { WrappedFieldProps } from 'redux-form';
import { AutoCompleteProps } from 'antd/lib/auto-complete';
import { useSelector } from 'react-redux';
import { getSubjectSelectOptionsNames } from 'logic/store/subject/subject.selectors';
import { SubjectSelectOptionNames } from 'logic/store/subject/subject.model';

interface OwnProps {
  additionalAntFormItemStyles?: any;
  formItemClassName?: string;
}

type FormSubjectNameSelectInputProps = WrappedFieldProps &
  AutoCompleteProps &
  FormItemProps &
  OwnProps;

export const FormSubjectNameSelectInput = ({
                                             additionalAntFormItemStyles,
                                             formItemClassName,
                                             label,
                                             labelCol,
                                             wrapperCol,
                                             required,
                                             meta,
                                             input,
                                             ...rest
                                           }: FormSubjectNameSelectInputProps) => {
  const errorMessage = !!meta && meta.error;
  const showError = !!meta && meta.touched && !!meta.error;
  const [searchPhrase, setSearchPhrase] = React.useState<string | undefined>(undefined);
  const { value, onBlur, onChange, ...restInput } = input;
  const subjectOptions = useSelector(getSubjectSelectOptionsNames);

  const handleOnSelect = (searchPhrase: string) => onChange(searchPhrase);
  const handleOnChange = (searchPhrase: string) => {
    setSearchPhrase(searchPhrase);
    if (!searchPhrase) {
      onChange(searchPhrase);
    }
  };
  const handleOnBlur = () => setSearchPhrase(undefined);
  const filterOption = (inputValue: string, option: SubjectSelectOptionNames | undefined) =>
    !inputValue || option?.label?.toLowerCase().includes(inputValue.toLowerCase());

  return (
    <Form.Item
      style={additionalAntFormItemStyles}
      className={formItemClassName}
      label={label}
      required={required}
      validateStatus={showError ? 'error' : undefined}
      help={showError ? errorMessage : undefined}
      labelCol={labelCol}
      wrapperCol={wrapperCol}
    >
      <AutoComplete
        value={searchPhrase || value}
        options={subjectOptions}
        onSelect={handleOnSelect}
        filterOption={filterOption as any}
        onChange={handleOnChange}
        onBlur={handleOnBlur}
        {...restInput}
        {...rest}
      />
    </Form.Item>
  );
};

export const FormEliteSubjectNameSelectInput = ({
                                             additionalAntFormItemStyles,
                                             formItemClassName,
                                             label,
                                             labelCol,
                                             wrapperCol,
                                             required,
                                             meta,
                                             input,
                                             ...rest
                                           }: FormSubjectNameSelectInputProps) => {
  const errorMessage = !!meta && meta.error;
  const showError = !!meta && meta.touched && !!meta.error;
  const [searchPhrase, setSearchPhrase] = React.useState<string | undefined>(undefined);
  const { value, onBlur, onChange, ...restInput } = input;
  //TODO DIRTY IMPLEMENTATION
  const subjectOptions = [
    {
      label: 'Mathe',
      value: 'Mathe',
    },
    {
      label: 'Physik',
      value: 'Physik',
    },
    {
      label: 'Deutsch (Schule)',
      value: 'Deutsch (Schule)',
    },
    {
      label: 'Englisch',
      value: 'Englisch',
    },
    {
      label: 'Latein',
      value: 'Latein',
    },
    {
      label: 'Chemie',
      value: 'Chemie',
    },
    {
      label: 'Italienisch',
      value: 'Italienisch',
    },
    {
      label: 'Spanisch',
      value: 'Spanisch',
    },
  ];

  const handleOnSelect = (searchPhrase: string) => onChange(searchPhrase);
  const handleOnChange = (searchPhrase: string) => {
    setSearchPhrase(searchPhrase);
    if (!searchPhrase) {
      onChange(searchPhrase);
    }
  };
  const handleOnBlur = () => setSearchPhrase(undefined);
  const filterOption = (inputValue: string, option: SubjectSelectOptionNames | undefined) =>
    !inputValue || option?.label?.toLowerCase().includes(inputValue.toLowerCase());

  return (
    <Form.Item
      style={additionalAntFormItemStyles}
      className={formItemClassName}
      label={label}
      required={required}
      validateStatus={showError ? 'error' : undefined}
      help={showError ? errorMessage : undefined}
      labelCol={labelCol}
      wrapperCol={wrapperCol}
    >
      <AutoComplete
        value={searchPhrase || value}
        options={subjectOptions}
        onSelect={handleOnSelect}
        filterOption={filterOption as any}
        onChange={handleOnChange}
        onBlur={handleOnBlur}
        {...restInput}
        {...rest}
      />
    </Form.Item>
  );
};
